import Axios from "axios";
import store from '@fg/base/store';
import lang from "@fg/base/filters/lang";

export class Request {
    constructor(scene) {
        this.scene = scene;
        this.scenario = undefined;
        this.previousScenario = undefined;
        this.ticketBarcode = undefined;
        this.ticketId = undefined;
        this.ticketAmount = undefined;
        this.demoId = undefined;
        this.ticketInProgress = false;
        this.gamePlayedTimes = 0;
        this.amountWon = 0;
        this.explanationStatus = false;
        this.demoGamesPlayed = 0;
        this.setCompleteInProgress = false;
    }
    
    async purchase() {
        if(this.ticketInProgress) {
            return;
        }

        this.scene.beforePurchase();

        this.setTicketStatus(true);
        
        this.scenario = {};
        this.ticketId = undefined;
        this.ticketBarcode = undefined;
        this.ticketAmount = undefined;

        store.commit('setTicketBarcode', undefined);

        this.setAmountWon(0);

        if (Config.replay_scenario) {
            store.commit('setTicketBarcode', Config.replay_barcode);
            this.ticketBarcode = Config.replay_barcode;
            this.scenario = Config.replay_scenario;
            this.ticketAmount = Config.current_amount.amount;
            this.scene.afterPurchase();
            return;
        }

        try {
            const { data: retrieved } = await Axios.post(Config.route.purchase, {
                mode: Config.mode,
                game_id: Config.game_id,
                shop_id: Config.shop_id,
                amount_id: Config.current_amount.id,
                replay_id: Config.replay_id,
                choice: this.choice ? this.choice : undefined,
                retrying: this.retrying? this.retrying : undefined
            });

            const res = this.parseResponse(retrieved);

            this.markPlayerText(res, () => {
                if (res.success) {
                    this.previousScenario = this.scenario;
                    this.scenario = res.scenario;
                    this.ticketId = res.id;
                    this.ticketBarcode = res.barcode;
                    this.ticketAmount = res.amount;
                    this.demoId = res.demo_id;
                    store.commit('setBalance', res.balance);
                    store.commit('setTicketBarcode', res.barcode);

                    if (Config.mode != 'demo') {
                        parent.postMessage({ 'balance':true }, '*');
                    }

                    this.reportEvent('purchase');

                    this.scene.afterPurchase();
                } else {
                    if (res.info != 'player_text') {
                        if(res.info == 'wrong_balance' && typeof Config.wallet_page !== 'undefined') {
                            this.showWalletError(res.text);
                        } else {
                            this.markError(res.text || lang('general_error'), () => {
                                if (res.info == 'return_home') {
                                    this.redirectToHome();
                                }

                                if (res.info == 'please_login') {
                                    parent.postMessage({ auth: true }, '*');
                                }
                            });
                        }
                    }

                    this.setTicketStatus(false);
                }
            });
        } catch (err) {
            console.error(err);
            this.setTicketStatus(false);
            this.markError(lang('general_error'), () => {
                this.redirectToHome();
            });
        }
    }

    redirectToHome() {
        if (Config.redirect_to_home && Config.home_url) {
            if (General.is_iframe()) {
                parent.postMessage({'open_location' : Config.home_url}, '*');
            } else if (General.has_parent()) {
                window.open(Config.home_url, '_top')
            } else {
                window.location.replace(Config.home_url);
            }
        }
    }

    loadWaitingTicket(waitingTicket) {
        this.setTicketStatus(true);
        this.scenario = waitingTicket.scenario;
        this.ticketId = waitingTicket.id;
        this.ticketBarcode = waitingTicket.barcode;
        this.ticketAmount = waitingTicket.amount;
        this.setAmountWon(0);

        store.commit('setTicketBarcode', waitingTicket.barcode);

        store.commit('setMessage', {
            title: 'message',
            message: lang('unfinishedGame'),
            callback: {title:'ok', callback: () => {
                this.scene.afterPurchase();
            }},
        });
    }

    parseResponse(res) {
        if (!res.blob) {
            return res;
        }

        return JSON.parse(atob(res.blob));
    }

    async setComplete() {
        try {
            this.setCompleteInProgress = true;

            const { data: retrieved } = await Axios.post(Config.route.complete, {
                mode: Config.mode,
                ticket_id: this.ticketId, 
                game_id: Config.game_id,
                shop_id: Config.shop_id
            });

            this.setCompleteInProgress = false;

            const res = this.parseResponse(retrieved);

            this.markPlayerText(res, () => {
                if (res.success) {
                    store.commit('setBalance', res.balance);
                    parent.postMessage({ 'balance':true }, '*');

                    this.reportEvent('complete');

                    this.setTicketStatus(false);
                } else if (res.info != 'player_text') {
                    this.markError(res.text || lang('general_error'), () => {
                        if (res.info == 'please_login') {
                            parent.postMessage({ auth: true }, '*');
                        }
                    });
                }
            });
        } catch (err) {
            console.error(err);
            this.setTicketStatus(false);
            this.setCompleteInProgress = false;
            this.markError(lang('general_error'));
        }
    }

    setTicketStatus(status) {
        this.ticketInProgress = status;
        store.commit('setTicketInProgress', status);
    }

    ticketFinished() {
        this.gamePlayedTimes++;
        this.setAmountWon(this.scenario.total_prize);

        if (Config.replay_scenario) {
            this.setTicketStatus(false);
            return;
        }

        if(Config.mode === 'demo') {
            this.setTicketStatus(false);
            this.demoGamesPlayed++;
            this.checkForPromoToReal();

            if (Config.demo_balance) {
                store.commit('setBalance', store.state.balance + this.scenario.total_prize);
            }
        } else {
            this.setComplete();
        }
    }

    checkForPromoToReal() {
        if(this.demoGamesPlayed > 4 && !Config.disableRealMoneySuggestion) {
            this.scene.changeToRealModal();
            this.demoGamesPlayed = 0;
        }
    }

    markError(text, after) {
        store.commit('setMessage', {
            title: 'message',
            message: text,
            callback: {
                title:'ok',
                callback:() => {
                    parent.postMessage({ error_close: true }, '*');

                    location.reload();

                    if (after) {
                        after();
                    }
                },
            },
        });
    }

    markPlayerText(res, after) {
        if (res.info == 'player_text') {
            store.commit('setMessage', {
                message: res.text,
                callback: {
                  title: 'ok',
                  callback: () => {
                      after();

                      if (res.action == 'reload') {
                          location.reload()
                      } else if (res.action == 'close' && Config.home_url) {
                          if (General.is_iframe()) {
                              parent.postMessage({'open_location' : Config.home_url}, '*');
                          } else if (General.has_parent()) {
                              window.open(Config.home_url, '_top')
                          } else {
                              window.location.replace(Config.home_url);
                          }
                      }
                  },
                },
            });
        } else {
            after();
        }
    }

    addAmountWon(amount) {
        this.amountWon += amount;

        store.commit('setAmountWon', this.amountWon);
    }

    setAmountWon(amount) {
        this.amountWon = amount;

        store.commit('setAmountWon', this.amountWon);
    }
    
    setExplanationStatus(status) {
        this.explanationStatus = status;

        if(typeof this.scene.afterExplanationToggle === 'function') {
            this.scene.afterExplanationToggle();
        }
    }

    showWalletError(text) {
        store.commit('setMessage', {
            title: 'message',
            message: text,
            type: 'add_funds',
            callback: {title:'add_funds', callback:()=>{
                    if (General.is_iframe()) {
                        parent.postMessage({'open_location' : Config.wallet_page}, '*');
                    } else if (General.has_parent()) {
                        window.open(Config.wallet_page, '_top')
                    } else {
                        window.location.replace(Config.wallet_page);
                    }
            }},
            callback2: {title:'close', callback:()=>{}},
        });
    }

    reportEvent(type) {
        if (!Config.analytics || Config.mode != 'real') {
            return;
        }

        setTimeout(() => {
            switch (type) {
                case 'purchase':
                    gameanalytics.GameAnalytics.addResourceEvent(
                        gameanalytics.EGAResourceFlowType.Source,
                        Config.currency_code.toUpperCase(),
                        Config.current_amount.amount,
                        'Purchase',
                        Config.shop_name,
                    );
                    break;
                case 'complete':
                    if (this.scenario.total_prize == 0) {
                        return;
                    }

                    gameanalytics.GameAnalytics.addResourceEvent(
                        gameanalytics.EGAResourceFlowType.Sink,
                        Config.currency_code.toUpperCase(),
                        this.scenario.total_prize,
                        'Payout',
                        Config.shop_name,
                    );
                    break;
                case 'bonus_start':
                    gameanalytics.GameAnalytics.addProgressionEvent(
                        gameanalytics.EGAProgressionStatus.Start,
                        'Bonus'
                    );
                    break;
                case 'bonus_end':
                    gameanalytics.GameAnalytics.addProgressionEvent(
                        gameanalytics.EGAProgressionStatus.Complete,
                        'Bonus'
                    );
                    break;
            }
        });
    }
}
